<template>
  <b-card
    text-variant="white"
    img-alt="card img"
    body-class="bg-overlay"
  >
    <b-card-body
      :id="`auto-chat-account-${account.id}`"
      class="statistics-body"
    >
      <b-row>
        <b-col
          md="12"
          class="mb-1"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="26"
                :variant="color"
              >
                <feather-icon icon="MonitorIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                <span> {{ $t('Account name') }}: {{ account.name }}</span>
              </h4>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="12"
          class="mb-1"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="26"
                :variant="color"
              >
                <feather-icon icon="GlobeIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0 font-medium-1">
                {{ $t("Type") }} : {{ account.display_type }}
              </h6>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="12"
          class="mb-1"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="26"
                :variant="color"
              >
                <font-awesome-icon :icon="icon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0 font-medium-1">
                {{ $t("Status") }} : {{ account.display_server_status }}
              </h6>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="12"
          class="mb-2"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="26"
                :variant="color"
              >
                <feather-icon icon="SendIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0 font-medium-1">
                {{ $t("Today Messages") }} : {{ account.sent_today }}
              </h6>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="12"
          class="d-flex justify-content-center"
        >
          <b-button
            :variant="account.is_connected ? 'success' : 'warning'"
            @click="accountClick"
          >
            <feather-icon
              :icon="account.is_connected ? 'EyeIcon' : 'ActivityIcon'"
              class="mr-50"
            />
            <span
              v-if="account.is_connected"
              class="align-middle"
            >{{ $t('Show account') }}</span>
            <span
              v-else
              class="align-middle"
            >{{ $t('Connect account') }}</span>
          </b-button>
          <b-button
            variant="danger"
            class="ml-2"
            @click="$emit('onDeleteButtonClicked',account)"
          >
            <feather-icon
              icon="TrashIcon"
              class="mr-50"
            />
            <span
              class="align-middle"
            >{{ $t('Delete account') }}</span>
          </b-button>
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

import {
  BCard, BCardTitle, BCardText, BCardHeader, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BButton,
} from 'bootstrap-vue'

export default {
  name: 'AccountCard',
  components: {
    BCard, BCardTitle, BCardText, BCardHeader, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BButton,
  },
  props: {
    account: {
      type: Object,
      default: () => {
      },
    },
  },

  data() {
    return {
      icon: '',
      color: '',
    }
  },
  mounted() {
    if (this.account.is_connected) {
      this.icon = 'fa-solid fa-signal-perfect'
      this.color = 'light-success'
    } else {
      this.icon = 'fa-solid fa-power-off'
      this.color = 'light-danger'
    }
  },
  methods: {
    accountClick() {
      if (this.account) {
        this.$router.push({
          name: 'accounts-show',
          params: { id: this.account.id },
        })
      } else {
        this.$router.push({
          name: 'dashboard-payment',
          params: { id: this.account.id },
        })
      }
    },
  },
}
</script>

<style scoped>

</style>
